import { Navigate, useLocation } from 'react-router-dom';

import MedsiCheckFull from 'assets/medsi-check-full.png';
import MobileScan from './MobileScan';
import { PATH_ROUTES } from 'routes/path';

export default function MobileQrFaceScan() {
  const { pathname, search } = useLocation();

  if (pathname.endsWith('/'))
    return <Navigate to={PATH_ROUTES.MOBILE_QR_SCAN + search} replace />;

  return (
    <>
      <div className='relative flex font-isidora'>
        <div className='w-full'>
          <nav className='flex items-center justify-center h-14 bg-primary-dark'>
            <div className='h-6 w-fit'>
              <img
                src={MedsiCheckFull}
                alt='medsicheck'
                className='object-cover w-full h-full'
              />
            </div>
          </nav>

          <main className='relative'>
            <MobileScan />
          </main>
        </div>
      </div>
    </>
  );
}
